import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import ElementUI from "element-ui";
import Vant from "vant";
import "vant/lib/index.css";
import "element-ui/lib/theme-chalk/index.css";
import filters from "./util/filters";
import importDirective from "@/directive";
import VueAMap from "vue-amap";
import moment from "moment";


Vue.config.productionTip = false;

Vue.use(VueAMap);
Vue.use(ElementUI);
Vue.use(Vant);
importDirective(Vue);

for (const key in filters) {
  Vue.filter(key, filters[key]);
}

Vue.filter("questionTypeCN", function(value) {
  if (value == "select") return "下拉题";
  else if (value == "radio") return "单选题";
  else if (value == "checkbox") return "多选题";
  else if (value == "input") return "填空题";
  else return "未知题型";
});

Vue.filter("dateTimeBeautify", function(value) {
  const dateTime = moment(value);
  if (dateTime.isValid()) {
    return dateTime.format("YYYY-MM-DD HH:mm:ss");
  } else {
    return value;
  }
});

// 判断权限指令。支持传入数组或字符串
Vue.directive("role", {
  bind: function(el, binding, vnode) {
    const role = store.getters.role;

    if (
      Array.isArray(binding.value)
        ? !binding.value.includes(role)
        : binding.value !== role
    ) {
      el.style.display = "none";
    }
  }
});

VueAMap.initAMapApiLoader({
  key: "ffb0d531c92cd8191e88cd8f375476ff",
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor"
  ],

  v: "1.4.4" // 默认高德 sdk 版本为 1.4.4
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
